var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import { noCache } from "../../services/middlewares/NoCacheMiddleware.js";
import { UnifiedRestServiceBase } from "./ExpAPIVUnified.resource.js";
import { buildOdataQuery } from "@ane/core/lib/utils/ODataUtils";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ExperimentationGroupSettingsResource = class extends UnifiedRestServiceBase {
  constructor() {
    super("experimentation-group-settings");
  }
  getSettingsForEgAsync(workspaceId, egId) {
    return __async(this, null, function* () {
      const result = yield this._get(
        buildOdataQuery(void 0, {
          baseUrl: this.getResourceUrl(this.getWorkspaceEgPath(workspaceId, egId), void 0, true),
          additionalQueryParams: this.getDefaultQueryParams()
        })
      );
      if (result.statusCode === 404) {
        result.statusCode = 200;
      }
      return result;
    });
  }
  updateSettingsForEgAsync(workspaceId, egId, settingsId) {
    return this._put(
      void 0,
      buildOdataQuery(void 0, {
        baseUrl: this.getResourceUrl(this.getWorkspaceEgPath(workspaceId, egId), settingsId, true),
        additionalQueryParams: this.getDefaultQueryParams()
      })
    );
  }
};
ExperimentationGroupSettingsResource = __decorateClass([
  noCache(),
  WPSProxyConverter()
], ExperimentationGroupSettingsResource);
const ExperimentationGroupSettingsResource$1 = new ExperimentationGroupSettingsResource();
export {
  ExperimentationGroupSettingsResource,
  ExperimentationGroupSettingsResource$1 as default
};
//# sourceMappingURL=ExperimentationGroupSettings.resource.js.map
